<template>
  <div class="invest_ment_manage">
    <table
      align="center"
      style="margin: auto"
      class="table_wrapper"
      border="1px"
      cellpadding="5px;"
      cellspacing="0"
      borderColor="#e0eeff"
    >
      <th class="first_td header_cell"></th>
      <th class="first_td header_cell"></th>
      <th class="header_cell">投后报告</th>
      <th class="header_cell">财务报表</th>
      <th class="header_cell">托管报告</th>
      <th class="header_cell">审计报告</th>
      <th class="header_cell">年报</th>
      <th class="header_cell">特殊事项报告</th>
      <template v-for="(item,index) in yearList">
        <tr v-for="(item_, index_) in item['children']">
          <td class="first_td header_cell" :key="'item_' + index_" rowspan="5" v-if="index_ == 0">
            <div>{{ item["fileMenuName"] }}</div>
            <div class="open_button" @click='switchOpenType(index)'  v-if="!item.openType"><i class="el-icon-arrow-down"></i> 展开  </div>
            <div class="open_button" @click='switchOpenType(index)'  v-if="item.openType"><i class="el-icon-arrow-up"></i> 收起  </div>
          </td>
          
          
          <td class="first_td header_cell" v-if="(item.openType&&index_<4)||index_==4">{{ item_.fileMenuName }}</td>
          <!-- <td class="first_td" v-if="index_==4">{{ item_.fileMenuName }}</td> -->
          <!-- index_==4 -->
          <td  v-if="index_==4" >
               
                 <span class="file_number">{{getFileNumber(item,'投后报告')}}</span>个文件
               
          </td>
          <td  v-if="index_==4" >
          
                 <span class="file_number">{{getFileNumber(item,'财务报表')}}</span>个文件
               
          </td>
          <td  v-if="index_==4" >
            
                 <span class="file_number">{{getFileNumber(item,'托管报告')}}</span>个文件
              
          </td>
          <td v-for="(el, i) in item_.children" :key="'el' + i" v-if="(item.openType&&index_<4)||index_==4">
            <div class="">
              <WordUpload
                v-if="!disabled"
                @showFileName="(el) => showFile(el, index,index_, i)"
                :baFileMenuId="item_.children[i]['id']"
                :id="id"
                :plain="false"
                :tip="false"
                :readonly="false"
              />
              <template v-for="(el_, i_) in el['files']">
                <div class="file_wrapper" :key="'el_' + i_">
                  <a
                    class="file_button"
                    target="_blank"
                    :href="
                      isWord(el_.fileUrl)
                        ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                          el_.fileUrl
                        : el_.fileUrl
                    "
                    type="text"
                    size="small"
                  >
                    {{ getFileName(el_.fileName) }}
                  </a>
                  <i
                    @click="downLoadFile(el_.id)"
                    class="el-icon-download del_icon"
                  ></i>
                  <i
                    v-if="!disabled"
                    @click="delFile(el_.id, index,index_, i, i_)"
                    class="el-icon-circle-close del_icon"
                  ></i>
                </div>
              </template>
            </div>
          </td>
          <td  v-if="item.openType&&index_<4">
               
               
             
           </td>
           <td  v-if="item.openType&&index_<4">
                  
                  
                
           </td>
           <td  v-if="item.openType&&index_<4">
                  
                  
                
           </td>
            

        </tr>

        <!-- <tr :key="index+'first'">
         <td rowspan="4">{{ item.fileMenuName }}:</td>
         <td >第一季度</td> 
         <td v-if="item['children'][0]" v-for="(el, i) in item['children'][0]['children']" :key="'el' + i">
            {{ el.fileMenuName }}
        
        
        </td> 
         

        </tr>
        <tr :key="index+'dier'" >  
          <td >第二季度</td> 
          <td v-if="item['children'][1]" v-for="(el, i) in item['children'][1]['children']" :key="'el' + i">
            {{ el.fileMenuName }}
        
        
        </td> 

        </tr>
        <tr :key="index+'disan'"> 
            <td >第三季度</td> 
            <td v-if="item['children'][2]" v-for="(el, i) in item['children'][2]['children']" :key="'el' + i">
            {{ el.fileMenuName }}
        
        
        </td> 

        </tr>
        <tr :key="index+'第四'"> 
            <td class="">第四季度</td> 
            <td v-if="item['children'][3]" v-for="(el, i) in item['children'][3]['children']" :key="'el' + i">
            {{ el.fileMenuName }}
        
        
        </td> 

        </tr> -->
      </template>

      <!-- <tr v-for="(item, index) in yearList" :key="index">
        <td>{{ item.fileMenuName }}:</td>
        <td v-for="(el, i) in item.children" :key="'el' + i">
          <div class="">
            <WordUpload
              v-if="!disabled"
              @showFileName="(el) => showFile(el, index, i)"
              :baFileMenuId="item.children[i]['id']"
              :id="id"
              :plain="false"
              :tip="false"
              :readonly="false"
            />
            <template v-for="(el_, i_) in el['files']">
              <div class="file_wrapper" :key="'el_' + i_">
                <a
                  class="file_button"
                  target="_blank"
                  :href="
                    isWord(el_.fileUrl)
                      ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                        el_.fileUrl
                      : el_.fileUrl
                  "
                  type="text"
                  size="small"
                >
                  {{ el_.fileName }}
                </a>
                <i
                  @click="downLoadFile(el_.id)"
                  class="el-icon-download del_icon"
                ></i>
                <i
                  v-if="!disabled"
                  @click="delFile(el_.id, index, i, i_)"
                  class="el-icon-circle-close del_icon"
                ></i>
              </div>
            </template>
          </div>
        </td>
        
      </tr> -->
    </table>
  </div>
</template>

<script>
import Vue from 'vue'
import * as dictionaries from "@/api/zd/dictionaries";
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util";
import WordUpload from "@/components/wordUpload/wordUpload";
import { downLoadTemplate, downLoadTemplateGet } from "@/router/downLoadTem";
import moment from "moment"
export default {
  name: "investMentManage",
  mixins: [workFlow, util],
  data() {
    return {
      // yearList: [{ year: "2022年度",fileList:[] }, { year: "2021年度" ,fileList:[]}],
      yearList: [],
    };
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 传入的详细数据
    bindData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    WordUpload,
    downLoadTemplate,
  },
  computed:{
    getFileName(){
      return function(name){
        let fileName=name.length>12?name.substr(0,8):name
        let ext = name.length>12?name.substring(name.lastIndexOf('.')):''
        return  `${fileName}${ext ? `${ext}` : ''}`
      }
    },
    getFileNumber(){
      return function(value,name){
         let number=0
         if(value.children){
         value.children.map(item=>{
          if(item.children){
           item.children.map(item_=>{
              if(item_.fileMenuName==name){
                number+= item_.files.length
              }
           })
          }
         })
        }
        return number
      }   
    },
  },
  mounted() {
    this.getFile();
  },
  methods: {
    getFile() {
      // this.yearList.map((item,i) => {
      //   this.getFileMenuByName(item.year,i,'fileList');
      // });
      this.getFileMenuList();
    },
    //fileName:子基金管理投后管理
    getFileMenuList() {
      dictionaries
        .getFileMenuListByName({
          dynamicId: this.$route.params.id,
          fileMenuName: "投后管理",
          fileMenuUrlname: "子基金管理",
          fileOtherId: this.$route.params.id,
          rootName: "子基金管理",
        })
        .then((res) => {
          let list = res.data.data;
          list.map((item) => {
            if (item.fileMenuName == "投后管理") {
              this.yearList = item.children;
              this.yearList.map(item=>{
                 item.openType=false
                 if(item.fileMenuName==(moment().year()+'年度')){
                  item.openType=true
                 }
              })
            }
          });
        })
        .catch((res) => {});
    },
    //上传附件回显
    showFile(data, index,index_, i, name) {
      this.yearList[index]["children"][index_]["children"][i]["files"] = data;
    },
    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
    //删除附件
    delFile(fileId, index,index_, i, i_) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this.yearList[index]["children"][index_]["children"][i]["files"].splice(i_, 1);
          // this[name].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
    // //通过名称获取菜单
    // getFileMenuByName(fileMenuName,i, name) {
    //   dictionaries
    //     .getFileMenuByName({ fileMenuName })
    //     .then((res) => {
    //       this.findFileByOtherId(res.data.data.id, name);
    //     })
    //     .catch((res) => {});
    // },
    // findFileByOtherId(baFileMenuId, i,name) {
    //   dictionaries
    //     .findFileByOtherId({
    //       fileOtherId: this.$route.params.id,
    //       baFileMenuId: baFileMenuId,
    //     })
    //     .then((res) => {
    //       // this.yearList[i][name] = res.data.data;
    //     })
    //     .catch((res) => {});
    // },
    switchOpenType(index){
      
      let  yearList=this.yearList
     
      yearList[index]["openType"]=!yearList[index]["openType"]
   
     
      Vue.set(this.yearList, index, yearList[index])
      
    }
  },
};
</script>
<style lang="scss" scoped>
.table_wrapper {
  text-align: center;
  width: 100%;
  margin: auto;
  th,
  td {
    height: 40px;
    line-height: 40px;
  }
  tr:nth-child(1) {
    width: 240px;
  }
  .first_td {
    width: 100px;
  }
}
.file_number,.open_button {

  color:#409EFF

}
.open_button {
  cursor: pointer;
}
.header_cell {
  background-color: #F6FAFF;
  font-weight: 400;

}
.invest_ment_manage {
  margin-top:20px
}
</style>